import preload from "../../../assets/Fading balls.gif";
function Preloader() {
  return (
    <div
      style={{
        textAlign: "center",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img style={{ width: "35px", height: "35px" }} src={preload} />
    </div>
  );
}

export default Preloader;
